import React from 'react';
import Layout from '../../../../components/Layout';
import { Button, DialogActions, Stack, Typography, useTheme } from '@mui/material';
import { buttonStyle2, buttonStyle3, dialogButtonCancel } from '../../../../utils/commonStyle';
import AddIcon from '@mui/icons-material/Add';
import { FieldArray, Formik, Form, useFormikContext } from 'formik';
import FormTextField from '../../../../components/FormTextField';
import ClearIcon from '@mui/icons-material/Clear';
import PhoneTextField from '../../../../components/PhoneTextField';



export default function AddEditContact({ type, verifierId, onClose, handleClose }) {
  const theme = useTheme();

  const { values,  dirty, isValid } = useFormikContext();

  return (
    <Stack
      style={{ backgroundColor: 'white' }}
      flex={1}
    >
      <Form autoComplete="off">
        <FieldArray
          name="contact"
          render={(arrayHelpers) => (
            <>
              <Stack
                direction={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
                style={{ backgroundColor: 'FFFFFF', marginTop: '10px' }}
              >
                <Typography
                  style={{ marginLeft: '25px' }}
                  className="fw-medium fs-18 ff-Roboto"
                  color={'#14285A'}
                >
                  Contacts
                </Typography>
                <Stack>
                  <Button
                    className="!mr-[16px] "
                    sx={[buttonStyle3, { width: '125px', height: '40px', fontSize: '12px' }]}
                    style={{
                      backgroundColor: theme.palette.primary.dark,
                      color: 'rgba(255, 255, 255, 1)',
                    }}
                    onClick={() => {
                      arrayHelpers.push({
                        contactId: '',
                        contactName: '',
                        contactDesignation: '',
                        contactEmail: '',
                        contactNumber: '',
                        phone: '',
                        phoneCode: '',
                      });
                    }}
                    variant="contained"
                    startIcon={<AddIcon />}
                  >
                    Add More
                  </Button>
                </Stack>
              </Stack>
              <Stack
                style={{ backgroundColor: theme.palette.border.main, height: '1px', marginBottom: '10px', marginTop: '10px', opacity: 0.5 }}
                className="mx-[25px]"
              />

              {values?.contact?.map((data, index) => (
                <Stack className="mx-[25px]">
                  <Stack
                    direction={'row'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                  >
                    <Typography
                      className="fw-medium fs-14 ff-Roboto"
                      color={'#14285A'}
                      style={{ marginBottom: '10px' }}
                    >
                      Contact person {index + 1}
                    </Typography>
                    {values?.contact?.length > 1 ? (
                      <Button
                        direction={'row'}
                        alignItems={'center'}
                        onClick={() => {
                          // removedFields.push({ renewalDocumentsId: values.contact[index].renewalDocumentsId });
                          arrayHelpers.remove(index);
                        }}
                        style={{ marginRight: '20px', marginBottom: '10px' }}
                        sx={{
                          color: '#F02323',
                          '&:hover': {
                            backgroundColor: theme.palette.grayBg.secondary,
                          },
                        }}
                      >
                        <ClearIcon style={{ transform: 'scale(0.643)' }} />
                        <Typography
                          className="fw-medium fs-14 ff-Roboto"
                          color={'#F02323'}
                        >
                          REMOVE
                        </Typography>
                      </Button>
                    ) : null}
                  </Stack>
                  <Stack
                    className="!flex"
                    sx={{
                      justifyContent: 'space-between',
                    }}
                  >
                    <FormTextField
                      name={`contact.${index}.contactName`}
                      outlineLabel={'Name'}
                      onlyAlpha={true}
                      requiredMark={true}
                      inputProps={{ maxLength: 51 }}
                    />
                    <FormTextField
                      name={`contact.${index}.contactDesignation`}
                      outlineLabel={'Designation'}
                      onlyAlpha={true}
                      requiredMark={true}
                      inputProps={{ maxLength: 51 }}
                    />
                    <FormTextField
                      name={`contact.${index}.contactEmail`}
                      outlineLabel={'Email Id'}
                      requiredMark={true}
                      inputProps={{ maxLength: 50 }}
                      lowerCase={true}
                    />
                    <PhoneTextField required variant="outlined" label="Phone No" name={`contact.${index}.phone`} name2={`contact.${index}.contactNumber`} name3={`contact.${index}.phoneCode`} />
                  </Stack>
                </Stack>
              ))}
            </>
          )}
        />

        <DialogActions
          style={{
            height: '66px',
            padding: '0',
            marginTop: '20px',
            marginRight: '20px',
          }}
          className="!mt-[200px] h-[66px] !justify-end p-[0px]"
        >
          <Button
            sx={[
              dialogButtonCancel,
              {
                color: theme.palette.primary.main,
                borderColor: '#14285A33',
                backgroundColor: '#14285A1A',
                '&:hover': {
                  // backgroundColor: theme.palette.secondary.main,
                  // color: theme.palette.background.main,
                  // borderColor: theme.palette.secondary.main,
                },
              },
            ]}
            style={{ width: '128px', marginLeft: '80px', height: '40px' }}
            variant="outlined"
            onClick={() => {
              handleClose();
              //   setConfirmVal('');
            }}
          >
            CANCEL
          </Button>
          <Button
            sx={[
              buttonStyle2,
              {
                color: theme.palette.background.main,
                backgroundColor: theme.palette.primary.dark,
                '&:hover': {
                  // backgroundColor: theme.palette.secondary.main,
                  // color: theme.palette.background.main,
                },
              },
            ]}
            style={{ width: '128px', height: '40px' }}
            disabled={!(dirty && isValid)}
            type="submit"
            variant="contained"
          >
            SAVE
          </Button>
        </DialogActions>
      </Form>
    </Stack>
  );
}
